export default [
  { id: '1', uri: 'portfolio', label: 'Portfolio' },
  { id: '2', uri: 'about', label: 'About Marc Sylvan' },
  { id: '3', uri: 'contact', label: 'Contact' }
];
